import "./icon.custom.caretUpCustom.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomCaretUpCustomProps = ComponentProps<"svg">
function IconCustomCaretUpCustom(props: IconCustomCaretUpCustomProps) {
  const {
    className,
    viewBox = "0 0 24 24",
    fill = "none",
    width = 16,
    height = 16,
    ...svgProps
  } = props

  return (
    <svg
      className={cn("caret-up-custom", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      aria-hidden
      {...svgProps}
    >
      <path className="caret-up-custom__path" d="M12 8L18 14H6L12 8Z" />
    </svg>
  )
}

export default IconCustomCaretUpCustom
